import { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ChatInput = ({ onSendMessage }) => {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    if (!message?.trim() || sending) return;

    try {
      setSending(true);
      await onSendMessage(message);
      setMessage('');
    } catch (error) {
      console.error('Error sending message:', error);
    } finally {
      setSending(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter' && !e?.shiftKey) {
      e?.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="p-4 lg:p-6 border-t border-border bg-card">
      <div className="flex items-end gap-3">
        {/* Attachment Button */}
        <button 
          className="p-2.5 rounded-md hover:bg-muted transition-smooth flex-shrink-0"
          disabled={sending}
        >
          <Icon name="Paperclip" size={20} className="text-muted-foreground" />
        </button>

        {/* Input Area */}
        <div className="flex-1 relative">
          <textarea
            value={message}
            onChange={(e) => setMessage(e?.target?.value)}
            onKeyPress={handleKeyPress}
            placeholder="Type your message..."
            rows={1}
            disabled={sending}
            className="w-full px-4 py-3 pr-12 rounded-lg border border-border bg-background resize-none focus:outline-none focus:ring-2 focus:ring-primary/20 transition-smooth text-sm disabled:opacity-50"
            style={{ minHeight: '44px', maxHeight: '120px' }}
          />
          <button className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 rounded-md hover:bg-muted transition-smooth">
            <Icon name="Smile" size={18} className="text-muted-foreground" />
          </button>
        </div>

        {/* Send Button */}
        <button
          onClick={handleSend}
          disabled={!message?.trim() || sending}
          className={`
            p-3 rounded-lg transition-smooth flex-shrink-0
            ${
              message?.trim() && !sending
                ? 'bg-gradient-to-br from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white shadow-md'
                : 'bg-muted text-muted-foreground cursor-not-allowed'
            }
          `}
        >
          {sending ? (
            <Icon name="Loader2" size={20} className="animate-spin" />
          ) : (
            <Icon name="Send" size={20} />
          )}
        </button>
      </div>

      {/* Quick Actions */}
      <div className="flex items-center gap-2 mt-3">
        <button className="text-xs text-muted-foreground hover:text-foreground transition-smooth flex items-center gap-1.5 px-3 py-1.5 rounded-md hover:bg-muted">
          <Icon name="MapPin" size={14} />
          Share Location
        </button>
        <button className="text-xs text-muted-foreground hover:text-foreground transition-smooth flex items-center gap-1.5 px-3 py-1.5 rounded-md hover:bg-muted">
          <Icon name="Calendar" size={14} />
          Schedule Meeting
        </button>
      </div>
    </div>
  );
};

export default ChatInput;